import { Box, Datepicker, Flex, Text } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";
import "./DateRange.scss";
import moment from "moment";

const DateRange = (props) => {
  const { t } = useTranslation();

  const { dateRange, handleDateRangeChange } = props;

  return (
    <Flex className="date-range-wrapper" gap="gap.small" >
      <Box className="Start-date-selector">
        <Text
          content={t("chart").screens.assignmets.subject.controls.date.date2[0]}
        />
        <Datepicker
          id="startDate-datePicker"
          popup={{
            mountNode: document.getElementsByClassName(
              "teacher-report-model"
            )[0],
          }}
          inputPlaceholder={
            t("chart").screens.assignmets.subject.controls.date.date1[0]
          }
          defaultSelectedDate={dateRange.startDate}
          style={{ margin: 0 }}
          onDateChange={(e, v) => {
            handleDateRangeChange({ ...dateRange, startDate: v.value });
          }}
        />
      </Box>
      <div className="End-date-selector">
        <Text
          content={t("chart").screens.assignmets.subject.controls.date.date3[0]}
        />

        <Datepicker
          inputPlaceholder={
            t("chart").screens.assignmets.subject.controls.date.date1[0]
          }
          defaultSelectedDate={dateRange.endDate}
          style={{ margin: 0 }}
          popup={{
            mountNode: document.getElementsByClassName(
              "teacher-report-model"
            )[0],
          }}
          onDateChange={(e, v) => {
            handleDateRangeChange({
              ...dateRange,
              endDate: new Date(
                moment(v.value)
                  .add({
                    hours: 23,
                    minutes: 59,
                  })
                  .toISOString()
              ),
            });
          }}
        />
      </div>
    </Flex>
  );
};

export default DateRange;
